import React from 'react';
import { DocumentIcon } from '@zola/zola-ui/src/components/SvgIcons/Document';
import { DeleteIcon } from '@zola/zola-ui/src/components/SvgIcons/DeleteIcon';
import styles from './styles.module.less';

type FloatingToolbar = {
  handleDelete: () => void;
  handleCloneElement: () => void;
};

const FloatingToolbar = (props: FloatingToolbar): JSX.Element => {
  const { handleDelete, handleCloneElement } = props;
  return (
    <div className={styles.floatingWrapper}>
      <span className={styles.button} data-testid="duplicate-button" onClick={handleCloneElement}>
        <DocumentIcon className={styles.icon} /> Duplicate
      </span>
      <span className={styles.button} data-testid="delete-button" onClick={handleDelete}>
        <DeleteIcon className={styles.icon} /> Delete
      </span>
    </div>
  );
};

export default FloatingToolbar;
